import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var FinyearListRes;
export const FinyearListTodo = createAsyncThunk('FinyearList', async (data) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'finanacial_year_list',
            data:{
                "vcustomer_code":localStorage.getItem('vcust_plant_code')
            },
            headers: { "Content-Type": "application/json" }
        })
        return FinyearListRes = res.data

    } catch (error) {
        return FinyearListRes = error.response.data
    }
})

const FinyearListSlice = createSlice({
    name: 'FinyearList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(FinyearListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('equipmentList', state.data.response)
        });
        builder.addCase(FinyearListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default FinyearListSlice.reducer; 